import axios from 'axios';
const API = import.meta.env.VITE_API_URL || 'http://localhost:3001';
export interface NewsSummary { id: string; title: string; summary: string; imageUrls: string[]; publishedAt: string | null; updatedAt: string }
export interface NewsEntry extends NewsSummary { body: string }
export interface NewsInput { title: string; summary: string; body: string; imageUrls: string[]; published: boolean }
export interface NewsPage { items: NewsSummary[]; page: number; total: number; hasMore: boolean; publishedTotal?: number }
export const news = {
  async move(id: string, direction: 'up' | 'down') { return (await axios.patch<{ moved: boolean; page: number }>(`${API}/admin/news/${encodeURIComponent(id)}/order`, { direction })).data; },
  async list(page = 1, admin = false, signal?: AbortSignal) { return (await axios.get<NewsPage>(`${API}/${admin ? 'admin/' : ''}news`, { params: { page }, signal })).data; },
  async get(id: string, admin = false, signal?: AbortSignal) { return (await axios.get<NewsEntry>(`${API}/${admin ? 'admin/' : ''}news/${encodeURIComponent(id)}`, { signal })).data; },
  async save(id: string | null, input: NewsInput) { return (await (id ? axios.patch<NewsEntry>(`${API}/admin/news/${id}`, input) : axios.post<NewsEntry>(`${API}/admin/news`, input))).data; },
  async remove(id: string) { await axios.delete(`${API}/admin/news/${id}`); },
  async upload(id: string, image: File) {
    const form = new FormData(); form.append('image', image);
    return (await axios.post<{ url: string }>(`${API}/admin/news/${id}/images`, form)).data;
  },
};
export function newsError(error: unknown) {
  return axios.isAxiosError(error) && typeof error.response?.data?.message === 'string'
    ? error.response.data.message : 'News could not be loaded or saved. Please try again.';
}
